const $ = document.querySelector.bind(document);
const $$ = document.querySelectorAll.bind(document);

////////////////////////////////////////////////////////////////// GLOBAL VUE PLUGINS
import FancyBox from './plugins/fancy-box/fancybox'
import axios from "axios";
Vue.use(FancyBox)
Vue.use(axios)

////////////////////////////////////////////////////////////////// GLOBAL VUE COMPONENTS
import BgImage from './components/bg-image/bg-image.vue'
Vue.component('BgImage', BgImage)

////////////////////////////////////////////////////////////////// GLOBAL VUE DIRECTIVES
import './directives/scroll-reveal/scroll-reveal'

////////////////////////////////////////////////////////////////// APP
import SideMenu from './components/side-menu/side-menu.vue'
import BgVideo from './components/bg-video/index.vue'
import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks
} from 'body-scroll-lock';

import {
    inlineOptions,
    galleryOptions
} from './imports/fancyOptions'

var app = new Vue({
    el: '#app',
    components: {
        SideMenu,
        BgVideo
    },
    data() {
        return {
            pageScrolled: false,
            sideMenuOpen: false,
            hideShopBtn: true,
            scrollDisabled: false,
            fancyboxInlineOpts: inlineOptions,
            fancyboxGalleryOpts: galleryOptions,
        }
    },
    methods: {
        onScroll() {
            this.pageScrolled = window.pageYOffset > 0;

            var body = document.body,
                html = document.documentElement;

            var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

            var fromTop = (window.pageYOffset || html.scrollTop) - (html.clientTop || 0);

            // var fromTop = window.scrollTop();

            if (fromTop > 200 && height - fromTop > 1400) {
                this.hideShopBtn = true;
            } else {
                this.hideShopBtn = false;
            }
        },
        toggleSideMenu() {
            if (!this.sideMenuOpen) {
                disableBodyScroll(this.scrollElement, {
                    // paddingRight: [document.querySelector('.header')],
                    // paddingRightElements: [document.body, $('.header'), $('#side-menu')],
                    paddingRightElements: [document.body, $('.header')],
                    reserveScrollBarGap: true,
                });
            } else {
                enableBodyScroll(this.scrollElement, {
                    reserveScrollBarGap: true
                });
            }
            this.sideMenuOpen = !this.sideMenuOpen;
        },

        // Awards
        loadMore(url) {
            axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            axios.get(url)
                .then(response => {
                    if (jQuery(response.data).find('#awardsLoadMore').length > 0) {
                        var resultHTML = jQuery(response.data).find('#awardsItemsContainer').html();
                        var res = Vue.compile(resultHTML)
                        var vm = new Vue({
                            render: res.render,
                            staticRenderFns: res.staticRenderFns
                        });
                        vm.$mount('#awardsItemsContainer')
                        // jQuery('#awardsItemsContainer').append(resultHTML);

                    }
                });
        }
    },
    created() {
        this.pageScrolled = window.pageYOffset > 0;
        window.addEventListener('scroll', this.onScroll, {
            passive: true
        });
    },
    mounted() {
        const component = this
        setTimeout(function () {
            component.hideShopBtn = false
        }, 1500);
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll);
    }
})


// WEBPACK FOOTER //
// ./src/js/app.js